import { createReducer, on } from '@ngrx/store';
import { withEntityReducer } from '@aston/foundation';

import * as featureActions from './actions';
import { initialState, IContactFormState } from './state';


// declare our fully typed reducer
export const ContactFormStoreReducer = createReducer(
	initialState,

	...withEntityReducer<IContactFormState>('form', featureActions.FormActions),

	on(featureActions.SubmitFormSuccess, state => ({
		...state,
		isOpened: false
	})),

	on(featureActions.ToggleForm, state => ({
		...state,
		isOpened: !state.isOpened
	})),
);
